<div class="meal-plan-card card-container-shadow">
  <ng-container *ngIf="editMode && goalToCreate && goalToCreate">
    <div class="meal-plan-card-header d-flex align-items-center justify-content-between">
      <div class="text-title-md text-upper-case tw-w-full">
        <nz-select nzShowSearch nzPlaceHolder="Selecciona la meta que quieras registrar" name="measurement"
          #ngMeasurement="ngModel" [(ngModel)]="goalToCreate.measurementId"
          [nzOptionHeightPx]="80" [nzShowSearch]="true" [nzOptionOverflowSize]="5" (ngModelChange)="onSelectMeasurement($event)">
          <ng-container>
            <nz-option nzCustomContent *ngFor="let option of optionsSearch" [nzValue]="option?._id"
              [nzLabel]="option?.name_es">
              <div class="custom-option-row-menu">
                <div class="text-info text-upper-case truncate" nz-popover="" nzPopoverTitle="" nzPopoverPlacement="top"
                  [nzPopoverContent]="option.tooltip ? tplTooltip : ''">

                  <ng-template #tplTooltip>
                    <div class="tw-w-80">{{option.tooltip || ''}}</div>
                  </ng-template>

                  <span nz-icon nzType="info-circle" nzTheme="outline" *ngIf="option.tooltip"></span>
                  {{ option?.name_es }}
                </div>
                <p class="text-info-sm text-lower-case first-letter-upper mt-xxs">
                  {{ option.description | getTranslateEnum:'patientGoalSearchDescription' }}
                </p>
                <nz-divider style="margin: 10px 0 0 0;"></nz-divider>
              </div>
            </nz-option>
          </ng-container>
        </nz-select>
      </div>
    </div>
    <div class="meal-plan-card-line mb-xs mt-xs"></div>

    <p class="tw-text-gray-400">{{ currentDate | date:'mediumDate' }}</p>

    <p class="tw-text-gray-500 tw-mt-5 tw-text-xs">Valor actual</p>
    <p *ngIf="!goalToCreate.metadata?.userValues" class="tw-text-gray-800 tw-font-semibold tw-text-2xl">
      {{goalToCreate.valueStart?.toFixed(2)}} {{ measurementUnitSymbol ? ( ' ' + measurementUnitSymbol) : '' }}</p>
    <p *ngIf="goalToCreate.metadata?.userValues" class="tw-text-gray-800 tw-font-semibold tw-text-2xl">
      {{goalToCreate.metadata.userValues[goalToCreate.valueStart]}}</p>

    <!-- secciones para agregar el valor deseado -->
    <p class="tw-text-gray-500 tw-mt-5">Agrega el valor deseado</p>
    <ng-container
      *ngTemplateOutlet="patientGoalType === patientGoalControlTypeEnum.NUMBER ? tplNumber : patientGoalType === patientGoalControlTypeEnum.SELECT ? tplSelect : patientGoalType === patientGoalControlTypeEnum.SLIDER ? tplSlider : tplRadio">
    </ng-container>

    <ng-template #tplNumber>
      <p class="tw-text-gray-500 tw-mt-1">Selecciona si deseas agregar un rango de valores</p>
      <nz-switch class="success-tint" [(ngModel)]="isValueRange" (ngModelChange)="onChangeGoalType()"></nz-switch>
      <div class="tw-flex tw-flex-col sm:tw-flex-row tw-items-start tw-gap-5 tw-mt-3">
        <ng-container *ngIf="!goalToCreate.metadata?.limits">
          <nz-input-number-group [nzAddOnAfter]="addOnAfterTemplate" class="tw-w-full">
            <nz-input-number [(ngModel)]="goalToCreate.goalStart" [nzMin]="0" [nzStep]="0.1"
              [nzPlaceHolder]="isValueRange ? 'Valor mínimo' : 'Valor'"></nz-input-number>
          </nz-input-number-group>

          <nz-input-number-group [nzAddOnAfter]="addOnAfterTemplate" *ngIf="isValueRange" @fadeInAnimation
            class="tw-w-full">
            <nz-input-number [(ngModel)]="goalToCreate.goalEnd" [nzMin]="goalToCreate.goalStart" [nzStep]="0.1"
              [nzPlaceHolder]="'Valor máximo'"></nz-input-number>
          </nz-input-number-group>
        </ng-container>

        <ng-container *ngIf="goalToCreate.metadata?.limits">
          <nz-input-number-group [nzAddOnAfter]="addOnAfterTemplate" class="tw-w-full">
            <nz-input-number [(ngModel)]="goalToCreate.goalStart" [nzMin]="goalToCreate.metadata.limits.start"
              [nzMax]="!isValueRange ? goalToCreate.metadata.limits.end : goalToCreate.goalEnd" [nzStep]="0.1"
              [nzPlaceHolder]="isValueRange ? 'Valor mínimo' : 'Valor'"></nz-input-number>
          </nz-input-number-group>

          <nz-input-number-group [nzAddOnAfter]="addOnAfterTemplate" *ngIf="isValueRange" @fadeInAnimation
            class="tw-w-full">
            <nz-input-number [(ngModel)]="goalToCreate.goalEnd" [nzMin]="goalToCreate.goalStart || 0"
              [nzMax]="goalToCreate.metadata.limits.end" [nzStep]="0.1" [nzPlaceHolder]="'Valor máximo'">
            </nz-input-number>
          </nz-input-number-group>
        </ng-container>

        <ng-template #addOnAfterTemplate>
          <p nz-popover="" nzPopoverTitle=""
            [nzPopoverContent]="measurementUnitSymbol ? '' : 'No se ha seleccionado la medición'">
            {{ measurementUnitSymbol ?? '¿?' }}
          </p>
        </ng-template>
      </div>
    </ng-template>

    <ng-template #tplSlider>
      <nz-slider *ngIf="goalToCreate.metadata?.limits" class="tw-w-full tw-mx-2 tw-relative"
        [(ngModel)]="goalToCreate.goalStart" [nzMin]="goalToCreate.metadata.limits.min"
        [nzMax]="goalToCreate.metadata.limits.min" [nzStep]="1" [nzTooltipVisible]="'never'"></nz-slider>
      <nz-slider *ngIf="!goalToCreate.metadata?.limits" class="tw-w-full tw-mx-2 tw-relative"
        [(ngModel)]="goalToCreate.goalStart" [nzStep]="1" [nzTooltipVisible]="'never'"></nz-slider>
    </ng-template>

    <ng-template #tplSelect>
      <nz-select nzShowSearch nzPlaceHolder="Selecciona la opción" [(ngModel)]="goalToCreate.measurementId"
        [nzShowSearch]="true" class="tw-mt-3">
        <ng-container *ngIf="goalToCreate.metadata?.userValues">
          <nz-option nzCustomContent *ngFor="let option of goalToCreate.metadata?.userValues | keyvalue"
            [nzValue]="option.key" [nzLabel]="option.value">
            <div class="custom-option-row-menu">
              <p class="text-info text-upper-case truncate">{{ option?.name_es }}</p>
              <p class="text-info-sm text-lower-case first-letter-upper mt-xxs">{{ option.description |
                getTranslateEnum:'measurementsCategory' }}</p>
              <nz-divider style="margin: 10px 0 0 0;"></nz-divider>
            </div>
          </nz-option>
        </ng-container>
      </nz-select>
    </ng-template>

    <ng-template #tplRadio>
      <nz-radio-group nzButtonStyle="solid" [(ngModel)]="goalToCreate.goalStart">
        <label nz-radio [nzValue]="+option.key"
          *ngFor="let option of goalToCreate.metadata?.userValues | keyvalue">{{option.value}}</label>
      </nz-radio-group>
    </ng-template>

    <!-- seccion para la fecha esperada -->
    <p class="tw-text-gray-500 tw-mt-5 tw-mb-2">Agrega la fecha estimada para cumplir la meta</p>
    <nz-date-picker [(ngModel)]="goalToCreate.goalDate" @fadeInAnimation [nzFormat]="this.platformConfig.FORMAT.DATE.DDMMYYYY"
      [nzPlaceHolder]="'Fecha estimada'" [nzDisabledDate]="utilitiesService.disabledPastDate">
    </nz-date-picker>
    <div class="mt-xlg d-flex justify-content-end">
      <button nz-button nzDanger nzType="primary" class="mr-xs" (click)="onCancel()">
        <i nz-icon nzType="close-circle" nzTheme="outline"></i>
        Cancelar</button>
      <button class="btn-save-time-food" nz-button nzType="primary" (click)="onSave()" [disabled]="
      !goalToCreate.measurementId ||
      !goalToCreate.goalDate ||
      (
      (goalToCreate.goalType === patientGoalNumberType.VALUE && !(goalToCreate.goalStart >= -4)) ||
      (goalToCreate.goalType === patientGoalNumberType.BETWEEN_VALUE && (!(goalToCreate.goalStart >= -4)  || !(goalToCreate.goalEnd >= -4))))
      ">
        <i nz-icon nzType="save" nzTheme="outline"></i>
        Guardar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="!editMode && goal">
    <div class="tw-flex tw-items-center tw-justify-between">
      <p class="text-title-md text-upper-case tw-flex tw-items-center">
        {{ goal.measurement?.name_es || 'no definido' }}
        <img *ngIf="goal.active" class="tw-w-5 tw-ml-2" nz-popover="" nzPopoverTitle=""
          [nzPopoverContent]="'La meta se encuetra activa'"
          src="./../../../assets/images/icons/icons8-comprobado-100.png" alt="">
      </p>
      <div class="more-options tw-flex tw-items-center" *ngIf="this.canInteract">
        <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar todo el progreso" class="icon-action danger"
          (click)="onDeleteGoalComplete(goal)">
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </div>
      </div>
    </div>
    <div class="meal-plan-card-line mb-xs mt-xs"></div>
    <div class="tw-flex tw-items-end tw-mt-5 tw-flex-wrap tw-gap-4">
      <div class="tw-flex tw-flex-col tw-items-start">
        <p class="tw-text-gray-500 tw-text-xs">Valor incial</p>
        <p *ngIf="!goal.metadata?.userValues" class="tw-text-gray-500 tw-font-semibold">{{goal.valueStart?.toFixed(2)}}
          <span class="tw-text-xs">{{goal.measureUnit.symbol_es}}</span></p>
        <p *ngIf="goal.metadata?.userValues" class="tw-text-gray-500 tw-font-semibold">
          {{goal.metadata.userValues[goal.valueStart]}}</p>
      </div>
      <div class="tw-flex tw-flex-col tw-items-start">
        <p class="tw-text-gray-500 tw-text-xs">Valor actual</p>
        <p *ngIf="!goal.metadata?.userValues" class="tw-text-gray-500 tw-font-semibold">{{ goal.lastValue?.toFixed(2) }}
          <span class="tw-text-xs">{{goal.measureUnit.symbol_es}}</span></p>
        <p *ngIf="goal.metadata?.userValues" class="tw-text-gray-500 tw-font-semibold">
          {{goal.metadata.userValues[goal.lastValue]}}</p>
      </div>
      <div class="tw-flex tw-flex-col tw-items-start">
        <p class="tw-text-gray-500 tw-text-xs">Meta final</p>
        <div class="tw-flex">
          <ng-container *ngIf="!goal.metadata?.userValues">
            <p class="tw-text-green-500 tw-font-semibold">{{ goal.goalStart?.toFixed(2) }} <span
                class="tw-text-xs">{{goal.measureUnit.symbol_es}}</span></p>
            <p class="tw-text-green-500 tw-font-semibold tw-ml-1.5"
              *ngIf="goal.goalType === patientGoalNumberType.BETWEEN_VALUE"> - {{ goal.goalEnd?.toFixed(2) }} <span
                class="tw-text-xs">{{goal.measureUnit.symbol_es}}</span></p>
          </ng-container>
          <ng-container *ngIf="goal.metadata?.userValues">
            <p class="tw-text-green-500 tw-font-semibold">{{ goal.metadata.userValues[goal.goalStart] }}</p>
            <p class="tw-text-green-500 tw-font-semibold tw-ml-1.5"
              *ngIf="goal.goalType === patientGoalNumberType.BETWEEN_VALUE"> - {{ goal.metadata.userValues[goal.goalEnd]
              }}</p>
          </ng-container>
        </div>
      </div>
      <div class="tw-flex tw-flex-col tw-items-start">
        <p class="tw-text-gray-500 tw-text-xs">Fecha estimada</p>
        <p class="tw-text-gray-500 tw-font-semibold">{{ goal.goalDate | date:'mediumDate' }}</p>
      </div>
    </div>

    <p class="tw-text-gray-500 tw-mt-5 tw-text-xs tw-mb-4">Progreso de la meta</p>
    <div class="tw-ml-5">
      <nz-timeline>
        <nz-timeline-item *ngFor="let item of goal.items; index as i">
          <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
            <div class="tw-flex tw-flex-wrap sm:tw-flex-nowrap tw-items-center tw-gap-3">
              <span nz-icon nzType="star" nzTheme="fill" class="tw-text-yellow-500"
                *ngIf="(item.value >= goal.goalStart && item.value <=  goal.goalEnd); else tplOutOfTime" nz-popover=""
                nzPopoverTitle="" nzPopoverContent="Fecha en la que se alcanzó la meta"></span>
              <ng-template #tplOutOfTime>
                <span *ngIf="item.createdAt | isAfterDate:goal.goalDate; else tplUpOrDownValue" nz-icon nzType="alert"
                  nzTheme="fill" class="tw-text-red-500" nz-popover="" nzPopoverTitle=""
                  nzPopoverContent="La fecha límite para cumplir la meta ha pasado"></span>
              </ng-template>
              <ng-template #tplUpOrDownValue>
                <span nz-icon
                  [nzType]="!goal.items[i+1] ? 'stop' : item.value === goal.items[i+1]?.value ? 'minus-square' : item.value > goal.items[i+1]?.value ? 'caret-up' : 'caret-down'"
                  nzTheme="fill"
                  [class]=" !goal.items[i+1] || item.value === goal.items[i+1]?.value ? 'tw-text-gray-400' : item.value < goal.items[i+1]?.value && item.value > goal.goalEnd ? 'tw-text-green-500' : item.value > goal.items[i+1]?.value && item.value < goal.goalStart ? 'tw-text-green-500' : 'tw-text-orange-500'"
                  nz-popover="" nzPopoverTitle="" [nzPopoverContent]="!goal.items[i+1] ? 'Valor inicial' : ''">
                </span>
              </ng-template>
              <span class="tw-text-gray-500">
                {{item.createdAt | date:'medium'}}
              </span>
              <span *ngIf="!goal.metadata?.userValues" class="tw-text-gray-800 tw-font-semibold">{{
                item.value?.toFixed(2) }} {{goal.measureUnit.symbol_es}}</span>
              <span *ngIf="goal.metadata?.userValues" class="tw-text-gray-800 tw-font-semibold">{{
                goal.metadata.userValues[item.value] }}</span>
              <ng-container *ngIf="!goal.metadata?.userValues">
                <span class="tw-text-gray-400"
                  *ngIf="(item.value >= goal.goalStart && item.value <=  goal.goalEnd); else tplNotInRangeItem">El valor
                  deseado se ha alcanzado</span>
                <ng-template #tplNotInRangeItem>
                  <p class="tw-text-gray-400">
                    {{ item.value > goal.goalEnd ? (item.value - goal.goalEnd)?.toFixed(2) + ' '
                    + goal.measureUnit.symbol_es + ' arriba del valor deseado' : (goal.goalStart -
                    item.value)?.toFixed(2) + ' ' + goal.measureUnit.symbol_es + ' abajo del valor deseado'}}
                  </p>
                </ng-template>
              </ng-container>
            </div>

            <div class="more-options tw-flex tw-items-center" *ngIf="this.canInteract">
              <div nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger"
                (click)="onDeleteGoal(item, i, goal._id)">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </div>
            </div>
          </div>
        </nz-timeline-item>
      </nz-timeline>
    </div>

    <p class="tw-text-gray-500 tw-text-xs tw-mb-2">¿Qué tan cerca se está de la meta?</p>
    <p class="tw-text-green-500 tw-bg-green-50 tw-rounded tw-w-max tw-p-3"
      *ngIf="(goal.lastValue >= goal.goalStart && goal.lastValue <=  goal.goalEnd); else tplNotInRange">
      El paciente se encuentra en el valor deseado
    </p>
    <ng-template #tplNotInRange>
      <p class="tw-text-blue-500 tw-bg-blue-50 tw-rounded tw-w-max tw-p-2">
        {{ goal.lastValue > goal.goalEnd ? (goal.lastValue - goal.goalEnd)?.toFixed(2) + ' '
        + goal.measureUnit.symbol_es + ' arriba del valor deseado' : (goal.goalStart - goal.lastValue)?.toFixed(2) + ' '
        + goal.measureUnit.symbol_es + ' abajo del valor deseado'}}
      </p>
    </ng-template>
  </ng-container>
</div>
